import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  lessonApi,
  tPromiseFromFunctionResolved,
  tLessonPhrases,
  tSharedAppState
} from 'common/modules/ReactShared';
import { isPreviewingLesson } from '../preview';

const initialLessonPhrases: tLessonPhrases = null;

const fetchLessonPhrases = createAsyncThunk<
  tPromiseFromFunctionResolved<typeof lessonApi.fetchLessonPhrases>['lessonPhrases'],
  number,
  { state: tSharedAppState }
>('lesson/fetchLessonPhrases_request', async (lessonId, { getState }) => {
  const { lessonPhrases } = await lessonApi.fetchLessonPhrases(
    lessonId,
    isPreviewingLesson(getState(), lessonId)
  );
  return lessonPhrases;
});

const lessonSlice = createSlice({
  name: 'phrases',
  initialState: initialLessonPhrases as tLessonPhrases,
  reducers: {
    drop: () => initialLessonPhrases
  },
  extraReducers: (builder) => {
    builder.addCase(fetchLessonPhrases.fulfilled, (_, action) => {
      return action.payload;
    });
  }
});

const { reducer, actions } = lessonSlice;
export const lessonPhrasesActions = { fetchLessonPhrases, ...actions };
export default reducer;
